import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http, $file } from '@/axios';
import { downloadFile } from '@/utils/helper';
import store from '@/store';
import router from '@/plugins/router';

// 查询材料列表
export const queryMaterials: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMaterials', { ...state.list, loading: true });
    // const res: IPageData = await $http.post('/material/type/item/page', payload);
    const res: IPageData = await $http.post('/v1/asset/material/pagelist', payload);
    commit('setMaterials', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setMaterials', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询材料详情
export const queryMaterialDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setMaterialDetail', { data: null, loading: true });
    // const res = await $http.get(`/material/type/item/detail/${payload}`);
    const res = await $http.get(`/v1/asset/material/${payload}/detail`);
    commit('setMaterialDetail', { data: res, loading: false });
  } catch (e) {
    commit('setMaterialDetail', { data: null, loading: false });
  }
};

// 查询颜色参数(这里单独用详情接口,是为了更新颜色信息时,只更新颜色模块的数据,不会导致整个详情页面刷新)
export const queryMaterialColor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setMaterialColor', { data: [], loading: true });
    // const res: { itemColorInfo: any } = await $http.get(`/material/type/item/detail/${payload}`);
    const res: { itemColorInfo: any } = await $http.get(`/v1/asset/material/${payload}/detail`);
    const data = res.itemColorInfo?.colors || [];
    commit('setMaterialColor', { data, loading: false });
  } catch (e) {
    commit('setMaterialColor', { data: [], loading: false });
  }
};

// 通过路径查询材料实例
export const queryInstances: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setInstances', { data: null, loading: true });
    // const res = await $http.post('/baseinfo/ueitem/materialinstance', payload);
    const res = await $http.post('/v1/ue/matinst/detail', payload);
    commit('setInstances', { data: res, loading: false });
  } catch (e) {
    commit('setInstances', { data: null, loading: false });
  }
};

// 查询贴图配置
export const queryConfigure: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setMaterialConfigure', { data: null, loading: true });
    // const res = await $http.post('/material/type/item/config', payload);
    const res = await $http.post('/v1/asset/material/configs', payload);
    commit('setMaterialConfigure', { data: res, loading: false });
  } catch (e) {
    commit('setMaterialConfigure', { data: null, loading: false });
  }
};

// 查询品牌详情(不受权限控制)
export const queryBrandDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setBrandDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/baseinfo/brand/${payload}/detail`);
    commit('setBrandDetail', { data: res, loading: false });
  } catch (e) {
    commit('setBrandDetail', { data: null, loading: false });
  }
};

// 查询材料类型下拉列表
export const queryMatItemTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setMatItemTypes', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/MaterialItemType');
    commit('setMatItemTypes', { data: res, loading: false });
  } catch (e) {
    commit('setMatItemTypes', { data: [], loading: false });
  }
};

// 添加材料
export const addMaterial: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // const res: { id: string } = await $http.post('/material/type/item/add', payload);
    const res: { id: string } = await $http.post('/v1/asset/material/add', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '添加成功, 2秒后跳转到编辑页面' });
    setTimeout(() => router.push({ name: 'materials-material-edit', params: { id: res.id } }), 2000);
  } catch (e) {
    commit('setLoading', false);
  }
};

// 编辑材料
export const editMaterial: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/material/type/item/modify', payload);
    await $http.post('/v1/asset/material/modify', payload);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } catch (e) {
    commit('setLoading', false);
  }
};

// 批量删除材料
export const batchDeleteMaterial: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/material/type/item/batch/delete', payload);
    await $http.post('/v1/asset/material/delete', payload);
    commit('setConfirm', { visible: false, loading: false });
  } catch (e) {
    commit('setConfirm', { visible: false, loading: false });
  }
};

// 批量上下架材料
export const batchShelfMaterial: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/material/type/item/batch/shelf', payload);
    await $http.post('/v1/asset/material/shelf', payload);
    commit('setConfirm', { visible: false, loading: false });
  } catch (e) {
    commit('setConfirm', { visible: false, loading: false });
  }
};

// 批量刷新材料索引
export const batchRefreshIndex: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/material/type/item/batch/refresh', payload);
    await $http.post('/v1/asset/material/refresh', payload);
    store.commit('common/setToast', { visible: true, text: '索引刷新成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 批量刷新材料颜色信息
export const batchRefreshColor: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/material/type/item/refresh/color', payload);
    await $http.post('/v1/asset/material/refreshcolor', payload);
    store.commit('common/setToast', { visible: true, text: '颜色刷新成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 更新材料缩略图
export const updateMaterialThumb: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setMaterialThumb', { ...state.thumb, loading: true });
    // const res = await $http.post('/material/type/item/modify/image', payload);
    const res = await $http.post('/v1/asset/material/modifyimage', payload);
    commit('setMaterialThumb', { data: res, loading: false });
  } catch (e) {
    commit('setMaterialThumb', { data: null, loading: false });
  }
};

// 更新材料颜色
export const updateMaterialColor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  // await $http.post('/material/type/item/modify/color', payload);
  await $http.post('/v1/asset/material/modifycolor', payload);
  store.commit('common/setToast', { visible: true, text: '颜色保存成功' });
};

// 新增价格
export const addMaterialPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogPrice'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogPrice;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    // await $http.post('/item/business/material/add', payload);
    await $http.post('/v1/asset/material/addprice', payload);
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 编辑价格
export const editMaterialPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogPrice'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogPrice;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    // await $http.post('/item/business/material/modify', payload);
    await $http.post('/v1/asset/material/modifyprice', payload);
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导出价格
export const exportMaterialPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogExport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogExport;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    // const res: { blob: Blob; filename: string } = await $file.post('/material/type/item/export', payload);
    const res: { blob: Blob; filename: string } = await $file.post('/v1/asset/material/exportprice', payload);
    downloadFile(res.blob, '物品价格列表');
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导入价格
export const importMaterialPrice: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogImport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogImport;

  try {
    const { type, file } = payload;
    const formData = new FormData();
    formData.append('type', type);
    formData.append('file', file);
    formData.append('fileName', file.name);
    store.commit(commitType, { ...commitState, loading: true });
    // await $http.post('/item/import', payload);
    await $http.post('/v1/asset/item/importprice', formData);
    store.commit('common/setToast', { visible: true, text: '价格导入成功' });
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导出关键字
export const exportMaterialKeyword: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogExport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogExport;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    // const res: { blob: Blob; filename: string } = await $file.post('/keyword/material/export', payload);
    const res: { blob: Blob; filename: string } = await $file.post('/v1/asset/material/exportkeywords', payload);
    downloadFile(res.blob, '物品关键字列表');
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导入关键字
export const importMaterialKeyword: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogImport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogImport;

  try {
    const { file } = payload;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    store.commit(commitType, { ...commitState, loading: true });
    // await $http.post('/keyword/material/input', payload);
    await $http.post('/v1/asset/material/inputkeywords', formData);
    store.commit('common/setToast', { visible: true, text: '关键字导入成功' });
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导出供应商
export const exportMaterialSupplier: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogExport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogExport;

  try {
    store.commit(commitType, { ...commitState, loading: true });
    // const res: { blob: Blob; filename: string } = await $file.post('/material/type/item/supplier/export', payload);
    const res: { blob: Blob; filename: string } = await $file.post('/v1/asset/material/exportsuppliercode', payload);
    downloadFile(res.blob, '材料供应商列表');
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 导入供应商
export const importMaterialSupplier: IActionFn<IModuleState> = async ({ rootState }, payload) => {
  const commitType = 'materials/common/setDialogImport'; // 对应的文件路径为: /src/store/materials/common/mutations
  const commitState = rootState.materials.common.dialogImport;

  try {
    const { file } = payload;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('fileName', file.name);
    store.commit(commitType, { ...commitState, loading: true });
    // await $http.post('/material/type/item/supplier/code/import', payload);
    await $http.post('/v1/asset/material/importsuppliercode', formData);
    store.commit('common/setToast', { visible: true, text: '供应商导入成功' });
  } finally {
    store.commit(commitType, { visible: false });
  }
};

// 查询材料已保存的过滤配置
export const queryMaterialFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setMaterialFilters', { data: [], loading: true });
    // const res = await $http.post('/material/type/item/filter/list', payload);
    const res = await $http.post('/v1/asset/material/filter/list', payload);
    commit('setMaterialFilters', { data: res, loading: false });
  } catch (e) {
    commit('setMaterialFilters', { data: [], loading: false });
  }
};

// 删除材料的过滤配置
export const deleteMaterialFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    // await $http.post('/material/type/item/filter/delete', payload);
    await $http.post('/v1/asset/material/filter/delete', payload);
    return true;
  } catch (e) {
    return false;
  }
};

// 保存材料的过滤配置
export const saveMaterialFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  // await $http.post('/material/type/item/filter/batch/modify', payload);
  await $http.post('/v1/asset/material/filter/modify', payload);
  store.commit('common/setToast', { visible: true, text: '保存成功' });
};
